<template>
  <el-dialog
    title="账户提现"
    :visible.sync="dialogVisible"
    width="70%"
    @close="clearForm"
  >
    <el-form ref="form" :model="form" label-width="120px" label-position="left">
      <el-form-item
        label="提现金额"
        prop="amount"
        :rules="[
          { required: true, message: '提现金额不能为空', trigger: 'blur' },
          { pattern: /^\d+(\.\d{1,2})?$/, message: '金额格式不正确', trigger: 'blur' }
        ]"
      >
        <el-input
          v-model="form.amount"
          placeholder="请输入提现金额"
          style="width: 100%"
        />
      </el-form-item>

      <el-form-item
        label="开户行"
        prop="bankId"
        :rules="[
          { required: true, message: '请选择开户行', trigger: 'change' }
        ]"
      >
        <el-select
          v-model="form.bankId"
          placeholder="请选择开户行"
          style="width: 100%"
        >
          <el-option
            v-for="item in accountBanks"
            :key="item.bankId"
            :label="item.bankName"
            :value="item.bankId"
          />
        </el-select>
      </el-form-item>

      <el-form-item
        label="申请说明"
        prop="context"
        :rules="[
          { required: true, message: '申请说明不能为空', trigger: 'blur' },
          { max: 500, message: '长度不能超过500个字符', trigger: 'blur' }
        ]"
      >
        <el-input
          v-model="form.context"
          type="textarea"
          placeholder="请输入申请说明"
          style="width: 100%"
        />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveAccountWithdrawalApplyInfo">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { queryAccountBank, saveAccountWithdrawalApply } from '@/api/goods/accountWithdrawalApplyApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AddAccountWithdrawalApply',
  data() {
    return {
      dialogVisible: false,
      form: {
        acctId: '',
        amount: '',
        context: '',
        accamount: '',
        objId: '',
        acctObjId: '',
        bankId: '',
        partId: ''
      },
      accountBanks: []
    }
  },
  methods: {
    open(shopAccount) {
      console.log(shopAccount)
      this.form = {
        ...this.form,
        acctId: shopAccount.acctId,
        accamount: shopAccount.amount,
        acctObjId: shopAccount.objId,
        partId: shopAccount.partId,
        objId: shopAccount.objId
      }
      this.dialogVisible = true
      this._listAddAccountBanks()
    },
    async _listAddAccountBanks() {
      console.log(this.form)
      try {
        const params = {
          page: 1,
          row: 50,
          shopId: this.form.objId
        }
        console.log(params)
        const res = await queryAccountBank(params)
        console.log(res.data)
        this.accountBanks = res.data
      } catch (error) {
        console.error('获取开户行列表失败:', error)
      }
    },
    async saveAccountWithdrawalApplyInfo() {
      this.$refs.form.validate(async valid => {
        if (!valid) return

        if (parseFloat(this.form.amount) > parseFloat(this.form.accamount)) {
          this.$message.error('提现失败！账户余额不足。')
          return
        }

        try {
          const res = await saveAccountWithdrawalApply(this.form)
          console.log(this.form)
          if (res.code === 0) {
            this.$message.success(res.msg)
            this.dialogVisible = false
            this.$emit('refresh')
          } else {
            this.$message.error(res.msg)
          }
        } catch (error) {
          console.error('保存提现申请失败:', error)
        }
      })
    },
    clearForm() {
      this.$refs.form.resetFields()
      this.form = {
        acctId: '',
        amount: '',
        context: '',
        accamount: '',
        objId: '',
        acctObjId: '',
        bankId: '',
        partId: ''
      }
    }
  }
}
</script>